

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authApi from "../../services/Api/authApi";
import { apiEndpoints } from "../../services/apiConfig";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const { data } = await authApi.login(credentials);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Login failed.");
    }
  }
);

export const signUpUser = createAsyncThunk(
  "auth/signUpUser",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await authApi.signup(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "signup failed.");
    }
  }
);

export const verifyUserOtp = createAsyncThunk(
  "auth/verifyUserOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await authApi.verifyOtp(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Invalid OTP");
    }
  }
);

export const resendUserOtp = createAsyncThunk(
  "auth/resendUserOtp",
  async (resend, { rejectWithValue }) => {
    try {
      const response = await authApi.resendOtp(resend);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const getUserDetails = createAsyncThunk(
  "auth/getUserDetails",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authApi.getUserDetails();
      localStorage.setItem("hrId", data?.data?.user_info?.user_pk);
      localStorage.setItem("userName", data?.data?.user_info?.first_name);
      localStorage.setItem("user_id", data?.data?.user_info?.user_pk);
      localStorage.setItem(
        "rating",
        data?.data?.user_info?.is_rating_submitted
      );
      localStorage.setItem("company_id", data?.data?.user_info?.company_id)
      // console.log(data.data, "check the get re user response");
      return data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  "auth/updateUserDetails",
  async (updateData, { rejectWithValue }) => {
    try {
      const { data } = await authApi.updateUser(updateData);
      return data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);


export const getUsersubscriptionDetails = createAsyncThunk(
  "auth/getUsersubscriptionDetails",
  async (updateData, { rejectWithValue }) => {
    try {
      const { data } = await authApi.getUsersubscriptionDetails();
      // console.log("data.data", data.data)
      return data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);

export const getDashboradData = createAsyncThunk(
  "auth/getDashboardData",
  async (updateData, { rejectWithValue }) => {
    try {
      const { data } = await authApi.getDashboardData();
      // console.log("data.data", data)
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);

export const getCreditHistory = createAsyncThunk(
  "auth/getCreditHistory",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authApi.creditHistory();
      // console.log("data.data", data)
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);
export const forgotUserPassword = createAsyncThunk(
  "auth/forgotUserPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await authApi.forgotPassword(payload);
      // console.log("data.data", data)
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);
export const resetUserPassword = createAsyncThunk(
  "auth/resetUserPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await authApi.resetPassword(payload);
      // console.log("data.data", data)
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);

export const checkTourStatus = createAsyncThunk(
  "auth/checkTourStatus",
  async (_, { rejectWithValue }) => {
    try {
      const userId = localStorage.getItem('user_id')
      const { data } = await authApi.checkTourStatus(userId);
      // console.log("data.data", data)
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);
export const closeAppTour = createAsyncThunk(
  "auth/closeAppTour",
  async (_, { rejectWithValue }) => {
    try {
      const userId = localStorage.getItem('user_id')
      const { data } = await authApi.closeAppTour(userId);
      // console.log("data.data", data)
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something Went wrong."
      );
    }
  }
);

// export const logoutUser = createAsyncThunk("auth/logoutUser", async () => {
//   const rememberedEmail = localStorage.getItem("rememberedEmail");
//   const rememberedPassword = localStorage.getItem("rememberedPassword");

//   localStorage.clear();


//   if (rememberedEmail) {
//     localStorage.setItem("rememberedEmail", rememberedEmail);
//   }

//   if (rememberedPassword) {
//     localStorage.setItem("rememberedPassword", rememberedPassword);
//   }
// });


export const logoutUser = createAsyncThunk("auth/logoutUser", async () => {
  try {
    // Save remembered values before clearing everything
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    const rememberedPassword = localStorage.getItem("rememberedPassword");

    // Clear all storage
    localStorage.clear();

    // Restore remembered credentials
    if (rememberedEmail) {
      localStorage.setItem("rememberedEmail", rememberedEmail);
    }

    if (rememberedPassword) {
      localStorage.setItem("rememberedPassword", rememberedPassword);
    }

    return true; // or any success signal
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
});

// Slice
const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    error: null,
    userData: [],
    resendLoading: false,
    message: "",
    isAuthenticated: !!localStorage.getItem("token"),
    userId: localStorage.getItem("userId") || null,
    resendMessage: "",
    userType: localStorage.getItem("userType") || null,
    subscriptionDetails: [],
    issubscriptionLoading: false, // ✅ Added this
    dashboardData: [],
    isloadingDatabase: false,
    isCreditHistoryLoading: false,
    creditData: [],
    resetPasswordData: null,
    tourStatus: {},
    tourStatusLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.isAuthenticated = !!action.payload.access_token;
        localStorage.setItem("token", action.payload.access_token);
        // console.log("action.payload.access_token", action.payload.access_token)
        // localStorage.setItem("userType", action.payload.user.user_type);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(signUpUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signUpUser.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.userId = action.payload.user_id; // ✅ store it in Redux
        localStorage.setItem("userId", action.payload.user_id);
      })
      .addCase(signUpUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutUser.pending, (state) => {
        state.loading = null;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(verifyUserOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyUserOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.userType = action.payload.usertype;
        state.isAuthenticated = !!action.payload.access_token;
        localStorage.setItem("userType", action.payload.usertype);
        localStorage.setItem("token", action.payload.access_token);
        localStorage.setItem("userId", action.payload.user_id);
      })

      .addCase(verifyUserOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(resendUserOtp.pending, (state) => {
        state.resendLoading = true;
        state.error = null;
      })
      .addCase(resendUserOtp.fulfilled, (state, action) => {
        state.resendLoading = false;
        state.resendMessage = action.payload.message;
      })
      .addCase(resendUserOtp.rejected, (state, action) => {
        state.resendLoading = false;
        state.error = action.payload;
      })
      .addCase(updateUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(updateUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUsersubscriptionDetails.pending, (state) => {
        state.issubscriptionLoading = true;
        state.error = null;
      })
      .addCase(getUsersubscriptionDetails.fulfilled, (state, action) => {
        state.issubscriptionLoading = false;
        state.subscriptionDetails = action.payload;
      })
      .addCase(getUsersubscriptionDetails.rejected, (state, action) => {
        state.issubscriptionLoading = false;
        state.error = action.payload;
      })
      .addCase(getDashboradData.pending, (state) => {
        state.isloadingDatabase = true;
        state.error = null;
      })
      .addCase(getDashboradData.fulfilled, (state, action) => {
        state.isloadingDatabase = false;
        state.dashboardData = action.payload;
      })
      .addCase(getDashboradData.rejected, (state, action) => {
        state.isloadingDatabase = false;
        state.error = action.payload;
      })
      .addCase(getCreditHistory.pending, (state) => {
        state.isCreditHistoryLoading = true;
        state.error = null;
      })
      .addCase(getCreditHistory.fulfilled, (state, action) => {
        state.isCreditHistoryLoading = false;
        state.creditData = action.payload;
      })
      .addCase(getCreditHistory.rejected, (state, action) => {
        state.isCreditHistoryLoading = false;
        state.error = action.payload;
      })
      .addCase(forgotUserPassword.pending, (state) => {
        state.isCreditHistoryLoading = true;
        state.error = null;
      })
      .addCase(forgotUserPassword.fulfilled, (state, action) => {
        state.isCreditHistoryLoading = false;
        state.resetPasswordData = action.payload;
      })
      .addCase(forgotUserPassword.rejected, (state, action) => {
        state.isCreditHistoryLoading = false;
        state.error = action.payload;
      })
      .addCase(resetUserPassword.pending, (state) => {
        state.isCreditHistoryLoading = true;
        state.error = null;
      })
      .addCase(resetUserPassword.fulfilled, (state, action) => {
        state.isCreditHistoryLoading = false;
        state.resetPasswordData = action.payload;
      })
      .addCase(resetUserPassword.rejected, (state, action) => {
        state.isCreditHistoryLoading = false;
        state.error = action.payload;
      })
      .addCase(checkTourStatus.pending, (state) => {
        state.tourStatusLoading = true;
        state.error = null;
      })
      .addCase(checkTourStatus.fulfilled, (state, action) => {
        state.tourStatusLoading = false;
        state.tourStatus = action.payload;
      })
      .addCase(checkTourStatus.rejected, (state, action) => {
        state.tourStatusLoading = false;
        state.error = action.payload;
      })
      .addCase(closeAppTour.pending, (state) => {
        state.tourStatusLoading = true;
        state.error = null;
      })
      .addCase(closeAppTour.fulfilled, (state, action) => {
        state.tourStatusLoading = false;
        state.tourStatus = action.payload;
      })
      .addCase(closeAppTour.rejected, (state, action) => {
        state.tourStatusLoading = false;
        state.error = action.payload;
      });
  },
});

export default authSlice.reducer;
